import { defineMessages } from 'react-intl';

export const freightBookingWizardMessages = defineMessages({
  title: {
    defaultMessage: 'Create Freight Shipment',
    id: 'Lvyx1K',
    description: 'Title for the freight booking wizard drawer',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'Jrq12v',
    description: 'Button label to cancel and close the wizard',
  },
  saveDraft: {
    defaultMessage: 'Save Draft',
    id: 'kg0tHB',
    description: 'Button label to save the wizard form as a draft quote',
  },
  bookShipment: {
    defaultMessage: 'Book Shipment',
    id: 'iL14Jx',
    description: 'Button label to book the freight shipment',
  },
  deleteDraft: {
    defaultMessage: 'Delete Draft',
    id: 'mFPvax',
    description: 'Button label to delete a pending freight draft quote',
  },
  save: {
    defaultMessage: 'Save',
    id: 'Nw6TaZ',
    description: 'Button label to save the current wizard step and advance',
  },
  edit: {
    defaultMessage: 'Edit',
    id: '6dM4LD',
    description: 'Link to reopen a completed wizard step',
  },
  shipFromStepTitle: {
    defaultMessage: 'Ship From',
    id: 'OfG+Yr',
    description: 'Title for the ship-from wizard step',
  },
  shipToStepTitle: {
    defaultMessage: 'Ship To',
    id: 'I2L8UH',
    description: 'Title for the ship-to wizard step',
  },
  handlingUnitsStepTitle: {
    defaultMessage: 'Handling Units',
    id: 'zLUc0z',
    description: 'Title for the handling-units wizard step',
  },
  additionalDetailsStepTitle: {
    defaultMessage: 'Additional Details',
    id: '9C9iPO',
    description: 'Title for the additional-details wizard step',
  },
  shipDateInPastError: {
    defaultMessage: 'Ship date cannot be in the past',
    description: 'Inline error shown below the Ship Date field when the saved ship date is in the past',
    id: 'oq5nBi',
  },
  shipDateTooFarAhead: {
    defaultMessage: 'Ship date cannot be more than {days} days from today',
    id: 'x9jlts',
    description: 'Error shown when the selected freight ship date is beyond the maximum days the carrier allows',
  },
});
